import { createSelector } from 'reselect';
import { NAME } from './constants';

const getEntities = state => state.getIn([NAME, 'entities']);
export const getUI = state => state.getIn([NAME, 'ui']);
export const getApp = state => state.getIn([NAME, 'app']);

export const getActive = createSelector(
  getEntities,
  state => getApp(state).get('active'),
  (entities, active) => {
    return active && entities.has(active) ? entities.get(active) : undefined;
  }
);

const filterUpcoming = sessions => {
  let today = new Date();
  today.setMinutes(0);
  today.setHours(0);
  today.setSeconds(0);
  today.setMilliseconds(0);
  return sessions.filter(
    session => session.get('startsAt') >= today.toISOString()
  );
};

// Get all sessions for today forward
export const getAllUpcoming = createSelector(getEntities, sessions => {
  sessions = sessions.toList();
  // Filter
  const sessionsFiltered = filterUpcoming(sessions);
  // Sort
  return sessionsFiltered.sortBy(session => session.get('startsAt'));
});

const getByClient = (state, props) => {
  const clientId = props.match.params.id; // @todo should check other potential vars e.g. props.clientId
  return getEntities(state)
    .toList()
    .filter(session => session.get('clientIds').includes(clientId));
};

// Get specific client sessions for today forward
export const getUpcomingByClient = createSelector(getByClient, sessions => {
  // Filter
  const sessionsFiltered = filterUpcoming(sessions);
  // Sort
  return sessionsFiltered.sortBy(session => session.get('startsAt'));
});



// WEBPACK FOOTER //
// ./src/modules/sessions/selectors.js